// eslint-disable-next-line @stylistic/max-len
export const PAGE_TITLE_ALL_NEW_PROMOTIONS_LIST = 'New Car Promotions';
export const PAGE_TITLE_NEW_CAR_PRICE_LIST = 'New Car Pricelist';
export const PILL_ACTIVE_BACKGROUND_COLOR_RED_1 = 'red-1';
export const PILL_ACTIVE_TEXT_WEIGHT_SEMIBOLD = 'semibold';
export const PILL_BACKGROUND_COLOR_GRAY_1 = 'gray-1';

// eslint-disable-next-line @stylistic/max-len
export const NO_SEARCH_RESULT_ALT = 'Mangifier with a question mark inside over an empty folder';

export const NO_SEARCH_RESULT_IMAGE = '/public/new-cars/no-search-results.svg';
export const NO_SEARCH_RESULT_IMAGE_WIDTH = 164;
export const NO_SEARCH_RESULT_IMAGE_HEIGHT = 144;

export const ELECTRIC_VEHICLES = 'ev';
export const ALL_NEW_PROMOTIONS = 'all';

export const ALL_STATUS = [
  { value: 'a', text: 'Available' },
  { value: 'e', text: 'Expired' },
] as const;
